module.exports = __webpack_public_path__ + "static/media/libras.ccadc63e.png";